/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ dose: NonNullable<unknown> }} Draft_Keep_DoseInputs */

const en_us2_draft_keep_dose = /** @type {(inputs: Draft_Keep_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Keep ${i?.dose}`)
};

const pt_br2_draft_keep_dose = /** @type {(inputs: Draft_Keep_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Manter ${i?.dose}`)
};

const es_419_draft_keep_dose = /** @type {(inputs: Draft_Keep_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Mantener ${i?.dose}`)
};

const pt_pt2_draft_keep_dose = /** @type {(inputs: Draft_Keep_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Manter ${i?.dose}`)
};

const fr_fr2_draft_keep_dose = /** @type {(inputs: Draft_Keep_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Garder ${i?.dose}`)
};

const de_de2_draft_keep_dose = /** @type {(inputs: Draft_Keep_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.dose} behalten`)
};

const it_it2_draft_keep_dose = /** @type {(inputs: Draft_Keep_DoseInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tieni ${i?.dose}`)
};

/**
* | output |
* | --- |
* | "Keep {dose}" |
*
* @param {Draft_Keep_DoseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_keep_dose = /** @type {((inputs: Draft_Keep_DoseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Keep_DoseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_keep_dose(inputs)
	if (locale === "es-419") return es_419_draft_keep_dose(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_keep_dose(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_keep_dose(inputs)
	if (locale === "de-DE") return de_de2_draft_keep_dose(inputs)
	if (locale === "it-IT") return it_it2_draft_keep_dose(inputs)
	return en_us2_draft_keep_dose(inputs)
});
export { draft_keep_dose as "draft.keep_dose" }